export enum Routes {
  Login = '/login',
  ForgottenPassword = '/forgotten-password',
  ActivationCode = '/activation-code/:activationCode',
  ResetPassword = '/reset-password/:token',
  Home = '/home',
  Profile = '/Profile',
  Dashboard = '/dashboard',
  UserManagement = '/UserManagement',
  Organisations = '/Organisations',
  OrganisationAdd = '/Organisations/AddNew',
  OrganisationEdit = '/Organisations/:organisationSlug/Edit',
  OrganisationHospitals = '/Organisations/:organisationSlug',
  OrganisationHospitalAdd = '/Organisations/:organisationSlug/AddNew',
  OrganisationHospitalEdit = '/Organisations/:organisationSlug/:hospitalSlug/Edit',
  OrganisationHospitalUsers = '/Organisations/:organisationSlug/:hospitalSlug',
  OrganisationHospitalUserEdit = '/Organisations/:organisationSlug/:hospitalSlug/:userSlug/Edit',
  OrganisationHospitalUser = '/Organisations/:organisationSlug/:hospitalSlug/:userSlug',
  AuditLog = '/AuditLog',
  Consultants = '/Consultants',
  Procedures = '/Procedures',
  Inventories = '/Inventories',
  Cards = '/Cards',
  ChangeRequests = '/ChangeRequests',
  ScanReview = '/ScanReview',
  ScanCheck = '/ScanCheck',
  ConsultantAssign = '/ConsultantAssign',
  ConsultantReview = '/consultant-review',
  Migration = '/Migration',
  MigrationAdd = '/Migration/AddNew',
  MigrationDetail = '/Migration/Details',
  LayingUp = '/LayingUp',
}
